import InputConfig from "../interfaces/inputConfig";
import { latLongPattern, emailPattern, numberPattern, textPattern, phoneNumberPattern } from "./patterns";

const FIELD_INPUT_CONFIG: Record<string, InputConfig> = {
    Email: {
        maxLen: 100,
        warningMsg: 'Please follow the following rules for email\nEmail must contain a single "@" symbol\nIt should have valid characters before and after "@"\nA domain name and top-level domain are required (e.g. ".com")\nDo not include spaces or special symbols other than ".", "-", "_", "+", and "%"',
        testRegex: emailPattern,
        inputType: 'email'
    },
    'Phone Number': {
        maxLen: 10,
        replaceRegex: numberPattern,
        inputType: 'tel',
        testRegex: phoneNumberPattern,
        warningMsg: 'Please follow the following rules for phone number\nPhone Number must contain exactly 10 digits'
    },
    lat_long: {
        maxLen: 100,
        warningMsg: 'Please follow the following rules for coordinates\nLatitude should be between -90 & 90\nLongitude should be between -180 & 180\nFormat is "<latitude>,<longitude>"\nLeave no spaces',
        testRegex: latLongPattern,
        inputType: 'tel'
    },
    Address: {
        maxLen: 500,
        replaceRegex: textPattern,
        inputType: 'text'
    },
    default: {
        maxLen: 100,
        replaceRegex: textPattern,
        inputType: 'text'
    },
};

export default FIELD_INPUT_CONFIG;